import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, Box, CircularProgress, Container, Snackbar } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { getFiltrarEventos, getListarEventos } from "../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import EventosTableComponent from "./components/EventosTableComponent";
import EventosHeader from "./components/EventosHeader";
import EventosFiltrosComponents from "./components/EventosFiltrosComponents";
import EliminarEventoModal from "./components/EliminarEventoModal";

const statusOptions = [
    { label: 'Vigentes', value: "vigentes", id: 1 },
    { label: 'Inactivos', value: "inactivos", id: 2 },
    { label: 'Todos', value: "todos", id: 3 },
];

function EventosAppPage() {
    const [loading, setLoading] = useState(false);
    const [dataEventos, setDataEventos] = useState([]);
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [loadingDashboard, setLoadingDashboard] = useState(true);
    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);

    const [loadingDeleteEvento, setLoadingDeleteEvento] = useState(false);
    const [showDeleteEventoModal, setShowDeleteEventoModal] = useState(false);
    const [idEventoDelete, setIdEventoDelete] = useState(null);

    const [statusFilter, setStatusFilter] = useState("todos");
    const [searchFilter, setSearchFilter] = useState("");


    //estado alert
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');




    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();



    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (searchFilter.length > 2) {

                handleApiFiltrarEventosTituloEstado(searchFilter, statusFilter);
            } else {
                handleApiFiltrarEventos(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, searchFilter, statusFilter, perPage]);









    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarEventosTituloEstado = (titulo, estado) => {

        let body = {
            page: 1,
            per_page: perPage,
            estado: estado,
            titulo: titulo
        };
        console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getFiltrarEventos(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarEventos", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataEventos(response.data);
                    setLoading(true);
                } else {
                    setDataEventos([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarEventos", error);
                setDataEventos([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };

















    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarEventos = (page = 1) => {

        let body = {
            page: page,
            per_page: perPage,
            estado: statusFilter,
            titulo: searchFilter
        };
        // console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getFiltrarEventos(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarEventos", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataEventos(response.data);
                    setLoading(true);
                } else {
                    setDataEventos([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarEventos", error);
                setDataEventos([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };


    // Handle per page change
    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };





    const handleEditarItem = (usuario) => {
        console.log("usuario a editar==>", usuario);

        history(`/app/admin/evento-detalle/${usuario.id}`);

    };

    const handleOpenModalDeleteEvento = (idEvento) => {
        setIdEventoDelete(idEvento);
        setShowDeleteEventoModal(true);
    };


    // Funciones para manejar el modal
    const handleAddEvento = () => {
        history('/app/admin/eventos-agregar');
    };


    // Handle status filter change
    const handleStatusChange = (value) => {
        setStatusFilter(value);
    };


    // Handle search change
    const handleSearchChange = (value) => {
        setSearchFilter(value);
    };





    const handleCloseModalDeleteEvento = () => {
        setShowDeleteEventoModal(false);
        setIdEventoDelete(null);
    };

    const handleDeleteEvento = () => {
        // setLoadingDeleteEvento(true);

        // // Llamar a la API para eliminar el evento
        // postEliminarEvento(stateToken?.token, idEventoDelete)
        //     .then(response => {
        //         console.log("response==>postEliminarEvento", response);
        //         setLoadingDeleteEvento(false);
        //         setShowDeleteEventoModal(false);
        //         setIdEventoDelete(null);

        //         // Mostrar mensaje de éxito
        //         setSeverity("success");
        //         setMensaje("Evento eliminado con éxito.");
        //         setOpen(true);

        //         // Refrescar la lista de eventos
        //         handleApiFiltrarEventos();
        //     })
        //     .catch(error => {
        //         console.log("error==>postEliminarEvento", error);
        //         setLoadingDeleteEvento(false);
        //         // Mostrar mensaje de error
        //         setSeverity("error");
        //         setMensaje("Error al eliminar el evento. Por favor, inténtalo de nuevo.");
        //         setOpen(true);
        //     });
    };









    //---------------------------------cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };






    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div className="max-w-7xl mx-auto">
                        {/* <div className="max-w-7xl mx-auto mt-20"> */}
                        <EventosHeader
                            title="Eventos"
                            subtitle="Administra y supervisa los eventos de la plataforma."
                            handleAdd={handleAddEvento}
                        />


                        <div>
                            <EventosFiltrosComponents
                                searchValue={searchFilter}
                                onSearchChange={handleSearchChange}
                                statusFilter={statusFilter}
                                onStatusChange={handleStatusChange}
                                statusOptions={statusOptions}
                            />

                            <EventosTableComponent
                                data={dataEventos}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarEventos}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditarItem}
                                handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
                            />


                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}



                {/*=============== Eliminar Evento Modal ===================*/}
                <EliminarEventoModal
                    isOpen={showDeleteEventoModal}
                    onClose={handleCloseModalDeleteEvento}
                    onSubmit={handleDeleteEvento}
                    loadingDeleteEvento={loadingDeleteEvento}
                />

                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>


                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} autoHideDuration={2000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                        {mensaje}
                    </Alert>
                </Snackbar>
            </div>
        </HeaderCustom>
    );
}

export default EventosAppPage;